import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { usePairing } from '../../_framework';

export const PairedCount: FC = () => {
	const { t } = useTranslation();
	const { paired } = usePairing();
	return <span className="font_900">{`${t('eventsPairing.pairedEvents')} (${paired.length})`}</span>;
};
